import { Alert, Button, Form, Input } from 'antd';
import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import UserApi from '../../functions/api/user/UserApi';

interface FormData {
  password: string;
  new_password: string;
  re_new_password: string;
}

export default function ChangePassword() {
  const history = useHistory();
  const [error, setError] = useState<string>();
  async function handleSubmit(values: FormData) {
    if (!values.password || !values.new_password || !values.re_new_password) {
      setError('Bạn chưa nhập đủ thông tin');
      return;
    }

    if (values.new_password !== values.re_new_password) {
      setError('Mật khẩu nhập lại không trùng khớp');
      return;
    }

    const credentials = {
      old_pass: values.password,
      new_pass: values.new_password,
    };

    const user = await UserApi.changePassword(credentials);

    if (user?.data) {
      history.replace('/');
      return;
    }

    setError(user?.message ?? 'Đã xảy ra lỗi, vui lòng thử lại sau ít phút !');
  }

  return (
    <div className="container">
      <Form
        layout="vertical"
        onFinish={handleSubmit}
        className="col-12 col-md-4 mx-auto"
      >
        <h2>Đổi mật khẩu</h2>
        {error && <Alert type="error" message={error} className="my-3" />}
        <Form.Item name="password" required label="Mật khẩu cũ">
          <Input type="password" />
        </Form.Item>
        <Form.Item name="new_password" label="Mật khẩu mới" required>
          <Input type="password" />
        </Form.Item>
        <Form.Item name="re_new_password" label="Nhập lại mật khẩu" required>
          <Input type="password" />
        </Form.Item>
        <Button htmlType="submit" block type="primary">
          Đổi mật khẩu
        </Button>
        <Link
          to="/"
          component={(props) => (
            <Button block type="default" className="mt-2" {...props}>
              Hủy
            </Button>
          )}
        />
      </Form>
    </div>
  );
}
